export default __webpack_public_path__ + "media/0185879e0c5f2cdd805a297e666ecc9c100adccb12062fd0c267b86f48824b53.svg";